import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	goalIconLabel: {
		id: 'software-goals.goal.icon.goal-icon-label',
		defaultMessage: 'Goal',
		description: 'ARIA label for the goal icon',
	},
});
